import type { Metadata } from 'next';

const CV_METATAG = {
  title: ' ISUZU TRUCKS Thailand Official ',
  description:
    'เจ้าแห่งรถบรรทุก อีซูซุ คิงออฟทรัคส์ - ISUZU TRUCKS Thailand Official',
  url: 'https://truck.isuzu-tis.com/',
  image:
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltd6be5b13bd044e9a/6601516eeee5d87634603537/og-isuzu-king-of-trucks-euro-5-max.jpg',
} as const;

export const CV_METADATA: Metadata = {
  title: CV_METATAG.title,
  description: CV_METATAG.description,
  openGraph: {
    title: CV_METATAG.title,
    description: CV_METATAG.description,
    url: CV_METATAG.url,
    images: [
      {
        url: CV_METATAG.image,
        width: 1200,
        height: 630,
      },
    ],
  },
  alternates: {
    canonical: CV_METATAG.url,
  },
};
